import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Mini Games
import Racetracks from "../Pages/GamesCorner/Racetracks.js";

//Rankings
import TrainerRankings from "../Pages/Rankings/TrainerRankings.js";
import PokemonRankings from "../Pages/Rankings/PokemonRankings.js";
import MapRankings from "../Pages/Rankings/MapRankings.js";
import CoinsRankings from "../Pages/Rankings/CoinsRankings.js";
import MoneyRankings from "../Pages/Rankings/MoneyRankings.js";
import MinerRankings from "../Pages/Rankings/MinerRankings.js";
import CatchRankings from "../Pages/Rankings/CatchRankings.js";

// Import Referral System
import ReferralSystem from "../Pages/Referral/ReferralSystem.js";

// Import Staff List
import StaffList from "../Pages/Staff/StaffList.js";

// Import Messages
import Inbox from "../Pages/Messages/Inbox.js";
import SendMessage from "../Pages/Messages/SendMessage.js";

import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import PlayerProfile from "../Pages/Profile/PlayerProfile.js";
import RuinValley from "../Pages/Maps/RuinValley.js";
// Import Utility Pages
import StarterPage from "../Pages/Utility/Starter-Page";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";

// Import Charts
import ApexCharts from "../Pages/Charts/ApexCharts";
import ChartJs from "../Pages/Charts/ChartjsCharts";
import FloatChart from "../Pages/Charts/FloatCharts";

// Import Map Pages
import LowVisibility from "../Pages/Maps/LowVisibility.js";

import CommunityLowVisibility from "../Pages/Maps/CommunityLowVisibility.js";
import PokemonPond from "../Pages/Maps/PokemonPond.js";
import Island from "../Pages/Maps/Island.js";
import TreasureBeach from "../Pages/Maps/TreasureBeach.js";
import RusturfTunnel from "../Pages/Maps/RusturfTunnel.js";
import DepartmentStoreMap from "../Pages/Shop/DepartmentStoreMap.js";
import GamesCornerMap from "../Pages/Maps/GamesCornerMap.js";
import SabrinaBuy from "../Pages/Shop/SabrinaBuy.js";
import EmberSpa from "../Pages/Maps/EmberSpa.js";
import SafariZoneNorth from "../Pages/Maps/SafariZoneNorth.js";
import SafariZoneEast from "../Pages/Maps/SafariZoneEast.js";
import SafariZoneSouth from "../Pages/Maps/SafariZoneSouth.js";
import SafariZoneWest from "../Pages/Maps/SafariZoneWest.js";
import Entrance from "../Pages/Maps/Entrance.js";
import Notifications from "../Pages/Notifcations/Notifications.js";
import BattleTowerEntrance from "../Pages/Maps/BattleTowerEntrance.js";
import Roster from "../Pages/Pokemon/Roster.js";
import Pokedex from "../Pages/Pokemon/Pokedex.js";
import Box from "../Pages/Pokemon/Box.js";

import ManageItems from "../Pages/Items/ManageItem.js";
import ManageTrades from "../Pages/Trades/ManageTrades.js";
import ManageBattles from "../Pages/PvP/ManageBattles.js";
import PvPBattleScreen from "../Pages/PvP/PvPBattleScreen.js";

import Profile from "../Pages/Profile/Profile.js";
import PromoCenterMap from "../Pages/Shop/PromoCenterMap.js";
import CollectionContest from "../Pages/GamesCorner/CollectionContest.js";

import SpriterDashboard from "../Pages/Spriter/SpriterDashboard.js";
import AdminPanel from "../Pages/Profile/AdminPanel.js";  
import Settings from "../Settings/Settings.js";

import WeeklyChallenges from "../Pages/Challenge/WeeklyChallenges.js";
import Valley from "../Pages/Maps/Ruin.js";
import SnowveilOutpost from "../Pages/Maps/SnowveilOutpost.js";
import Route25 from "../Pages/Maps/Route25.js";
import HomePage from "../Pages/Utility/HomePage.jsx";
import FAQPage from "../Pages/Utility/FAQPage.jsx";
import AboutPage from "../Pages/Utility/AboutPage.jsx";
import BoxRater from "../Pages/Utility/BoxRater.js";
import RateList from "../Pages/Utility/RateList.js";
import BattleTower from "../Pages/BattleTower/BattleTower.js";
import PlayerShop from "../Pages/Maps/PlayerShop.js";
import HalloweenEvent from "../Pages/Maps/Halloween_Event.js";
import SkillTree from "../Pages/Skills/SkillTree.js";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // E-mail
  { path: "/inbox", component: <Inbox /> },
  { path: "/send-message", component: <SendMessage /> },

  { path: "/story-mode", component: <ComingSoon /> },
  { path: "/pages-starter", component: <StarterPage /> },

  // Pokemon
  { path: "/pokedex", component: <Pokedex /> },
  { path: "/roster", component: <Roster /> },
  { path: "/box", component: <Box /> },

  { path: "/admin-panel", component: <AdminPanel /> },

  // Mini Games
  { path: "/racetracks", component: <Racetracks /> },
  // Hitdown migrated to Discord bot - use !hitdown command


  // Charts Pages
  { path: "/chart-apexcharts", component: <ApexCharts /> },
  { path: "/chart-chartjscharts", component: <ChartJs /> },
  { path: "/chart-floatcharts", component: <FloatChart /> },
  { path: "/battle-tower", component: <BattleTower /> },
  { path: "/battle-tower/60second", component: <BattleTower /> },
  { path: "/battle-tower/endless", component: <BattleTower /> },
  // Maps Pages
  //{ path: "/map/SafariZone", component: <SafariZone /> },
  { path: "/map/LowVisibility", component: <LowVisibility /> },
  { path: "/map/CommunityLowVisibility", component: <CommunityLowVisibility /> },
  { path: "/map/Route25", component: <Route25 /> },
  { path: "/map/PokemonPond", component: <PokemonPond /> },
  //{ path: "/map/RuinValley", component: <RuinValley /> },
  { path: "/map/RuinValley", component: <Valley /> },
  { path: "/map/RusturfTunnel", component: <RusturfTunnel /> },
  { path: "/map/Island", component: <Island /> },
  { path: "/map/TreasureBeach", component: <TreasureBeach /> },
  { path: "/map/SnowveilOutpost", component: <SnowveilOutpost /> },
  { path: "/map/EmberSpa", component: <EmberSpa /> },
  { path: "/map/SafariZoneNorth", component: <SafariZoneNorth /> },
  { path: "/map/SafariZoneEast", component: <SafariZoneEast /> },
  { path: "/map/SafariZoneSouth", component: <SafariZoneSouth /> },
  { path: "/map/SafariZoneWest", component: <SafariZoneWest /> },
  { path: "/map/SafariZone", component: <Entrance /> },
  { path: "/map/HalloweenEvent", component: <HalloweenEvent /> },
  { path: "/PlayerShop", component: <PlayerShop /> },
  { path: "/map/BattleTowerEntrance", component: <BattleTowerEntrance /> },

  { path: "/department-store", component: <DepartmentStoreMap /> },
  { path: "/sabrina-buy", component: <SabrinaBuy /> },
  { path: "/promo-center", component: <PromoCenterMap /> },
  { path: "/games-corner", component: <GamesCornerMap /> },
  { path: "/collection-contest", component: <CollectionContest /> },
  { path: "/manage-items", component: <ManageItems /> },
  { path: "/weekly-missions", component: <WeeklyChallenges /> },
  { path: "/manage-trades", component: <ManageTrades /> },
  { path: "/manage-battles", component: <ManageBattles /> },
  { path: "/pvp-battle/:battle_id", component: <PvPBattleScreen /> },

  // Rankings Pages
  { path: "/trainer-rankings", component: <TrainerRankings /> },
  { path: "/pokemon-rankings", component: <PokemonRankings /> },
  { path: "/miner-rankings", component: <MinerRankings /> },
  { path: "/money-rankings", component: <MoneyRankings /> },
  { path: "/catch-rankings", component: <CatchRankings /> },

  // Misc
  { path: "/referral-system", component: <ReferralSystem /> },
  { path: "/staff-list", component: <StaffList /> },
  { path: "/map-rankings", component: <MapRankings /> },
  { path: "/coins-rankings", component: <CoinsRankings /> },
  { path: "/spriter-dashboard", component: <SpriterDashboard /> },
  { path: "/box-rater", component: <BoxRater /> },
  { path: "/rate-list", component: <RateList /> },
  // Notifications
  { path: "/notifications", component: <Notifications /> },

  // Skills
  { path: "/skill-tree", component: <SkillTree /> },

  { path: "/profile", component: <Profile /> },
  { path: "/playerprofile", component: <PlayerProfile /> },
  { path: "/settings", component: <Settings /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  // Catch-all route for invalid paths - redirect to dashboard
  {
    path: "*",
    component: <Navigate to="/dashboard" replace />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/", exact: true, component: <HomePage /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
   { path: "/faq", component: <FAQPage /> },
   { path: "/about", component: <AboutPage /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  // Utility Pages
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },
  
  // Catch-all route for invalid public paths - redirect to home
  {
    path: "*",
    component: <Navigate to="/dashboard" replace />,
  },
];

export { authProtectedRoutes, publicRoutes };
